(() => {
  const closeBreakFree = (container, { restoreFocus = true } = {}) => {
    const trigger = container.querySelector('[data-break-free-trigger]');
    const dialog = container.querySelector('[data-break-free-dialog]');
    if (!trigger || !dialog || dialog.hidden) return;

    dialog.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    container.classList.remove('is-break-free-open');
    if (restoreFocus) trigger.focus();
  };

  const openBreakFree = (container) => {
    const trigger = container.querySelector('[data-break-free-trigger]');
    const dialog = container.querySelector('[data-break-free-dialog]');
    if (!trigger || !dialog) return;

    dialog.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    container.classList.add('is-break-free-open');
    dialog.querySelector('[data-break-free-close]')?.focus();
  };

  const updateMobilePurchaseBars = () => {
    document.querySelectorAll('.product-form').forEach((productForm) => {
      const total = productForm.querySelector('.result-list li.total .price-item--sale');
      const selectedSize =
        productForm.querySelector('.result-list li[data-option-name*="Size" i] .option-descr') ||
        document.querySelector('variant-selects input[name*="Size" i]:checked');

      productForm.querySelectorAll('[data-mobile-purchase-price]').forEach((element) => {
        if (total?.textContent.trim()) element.textContent = total.textContent.trim();
      });

      productForm.querySelectorAll('[data-mobile-purchase-selection]').forEach((element) => {
        const value = selectedSize?.textContent?.trim() || selectedSize?.value || 'Your crystal';
        element.textContent = value.includes('Tower') ? value : `${value} Tower`;
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ccm-purchase-reassurance]').forEach((container) => {
      container.querySelector('[data-break-free-trigger]')?.addEventListener('click', () => {
        const dialog = container.querySelector('[data-break-free-dialog]');
        if (dialog?.hidden) {
          openBreakFree(container);
        } else {
          closeBreakFree(container);
        }
      });

      container.querySelectorAll('[data-break-free-close]').forEach((close) => {
        close.addEventListener('click', () => closeBreakFree(container));
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.is-break-free-open').forEach((container) => closeBreakFree(container));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.productFormUpdated, updateMobilePurchaseBars);
    }

    updateMobilePurchaseBars();
  });
})();
